import React from 'react';
import { usePermissions } from '../../utils/usePermissions';
import { useAuth } from '../../contexts/AuthContext';

interface RequirePermissionProps {
  /** Один код права или массив кодов */
  code?: string;
  codes?: string[];
  /** Требовать все коды (по умолчанию: достаточно одного) */
  all?: boolean;
  /** Пропускать администраторов независимо от наличия пермишна (по умолчанию: false) */
  allowAdmin?: boolean;
  /** Фолбек, если нет прав (по умолчанию: null) */
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ code, codes, all = false, allowAdmin = false, fallback = null, children }) => {
  const { hasAny, hasAll } = usePermissions();
  const { isLoading, profile } = useAuth();

  const required = codes || (code ? [code] : []);
  if (!required.length) return <>{children}</>;

  if (isLoading) {
    return null;
  }

  if (allowAdmin && profile?.is_admin) return <>{children}</>;

  const allowed = all ? hasAll(required) : hasAny(required);

  if (!allowed) return <>{fallback}</>;
  return <>{children}</>;
};

export default RequirePermission;
